import { render, staticRenderFns } from "./Carroceria.vue?vue&type=template&id=760ed160"
import script from "./Carroceria.vue?vue&type=script&lang=js"
export * from "./Carroceria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports